// extracted by mini-css-extract-plugin
export default {"title":"title--t6APm","count":"count--Jixk0"};